<template>
  <div v-if="group && group.fields">
    <div class="text-tiles-wrapper">
      <h2 class="text-tile-heading secondary--text text-center">
        {{ group.fields.heading }}
      </h2>
      <ul class="d-flex justify-center">
        <li
          v-if="sortedEntries && sortedEntries.length"
          class="text-tile-grid-wrapper"
          :style="{ 'grid-template-columns': `repeat(${sortedEntries.length}, minmax(auto, 255px))` }"
        >
          <text-tile
            v-for="(tile, index) in sortedEntries"
            :key="'text-tile-group-item_' + tile.fields.description + '_' + index"
            :fields="tile.fields"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import TextTile from '@/components/slices/text-tiles/text-tile'

export default {
  name: 'TextTiles',
  components: {
    TextTile
  },
  props: {
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      group: {},
      sortedEntries: null
    }
  },
  async created () {
    const { items, includes } = await queryCTF(
      `&include=2&content_type=textTileGroup&select.fields&sys.id=${this.sysId}`
    )
    if (items && includes) {
      this.group = items[0]
      const entries = includes.Entry.filter(x =>
        this.group.fields.tiles.find(t => t.sys.id === x.sys.id)
      )
      const sortedEntries = sortCTFEntries(this.group.fields.tiles, entries)

      this.sortedEntries = sortedEntries.map(el => {
        const img = includes.Asset.find(a => a.sys.id === el.fields.iconImage.sys.id)
        const ret = { ...el }
        ret.fields.iconUrl = img.fields.file.url
        return ret
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

::v-deep p {
  margin-bottom: 0 !important;
}

.text-tile-heading {
  margin: 50px 0;
}

.text-tiles-wrapper {
  padding: 0 0 4em 0;
}

.text-tile-grid-wrapper {
  display: grid;
  grid-template-rows: repeat(auto-fill, 1fr);
  grid-gap: 60px 22px;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

@media (max-width: $breakpoint-sm) {
  .text-tile-grid-wrapper {
    grid-template-columns: repeat(2, minmax(auto, 255px)) !important;
  }
}

@media (max-width: $breakpoint-xs) {
  .text-tile-grid-wrapper {
    grid-template-columns: repeat(1, minmax(auto, 255px)) !important;
    grid-gap: 40px 22px;
  }
}
</style>
